import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.div`
  .toolTip-Icon {
    float: left;
    text-decoration: none;
    position: relative;
    height: 18px;
    width: 18px;
    cursor: pointer;
    color: ${palette("color", 16)};
    font-size: ${size("p4")};
    margin-left: 12px;
    margin-top: 3px;
  }

  .toolTip-Icon .icon{
    .circle {
      fill: ${palette("color", 29)};
    }
  }
`;

export default Wrapper;
